export const STATIC_HEADER_ORIGIN = "https://static.golibe.com";

const STATIC_HEADER_PATH_PATTERN = /^\/[A-Za-z0-9.-]+\/app\/head-v[0-9]+(?:\.[0-9]+)*(?:[-_][A-Za-z0-9]+)?\/index\.html$/;

type LocalizedUrls = {
  [key: string]: string | undefined;
};

export function isAllowedStaticHeaderUrl(value: string): boolean {
  if (!value || value !== value.trim()) {
    return false;
  }

  try {
    const url = new URL(value);
    const rawPathStart = value.indexOf("/", url.protocol.length + 2);
    const rawOrigin = value.slice(0, rawPathStart).toLowerCase();
    const rawPath = value.slice(rawPathStart);

    return (
      url.protocol === "https:" &&
      url.hostname.toLowerCase() === "static.golibe.com" &&
      rawOrigin === STATIC_HEADER_ORIGIN &&
      rawPath === url.pathname &&
      !url.username &&
      !url.password &&
      !url.port &&
      !url.search &&
      !url.hash &&
      STATIC_HEADER_PATH_PATTERN.test(url.pathname)
    );
  } catch (_error) {
    return false;
  }
}

export function resolveStaticHeaderUrl(
  urls: LocalizedUrls | undefined,
  language: string | null | undefined
): string | undefined {
  if (!urls) {
    return undefined;
  }

  const languageCode = language === "cs" ? "cz" : language;

  return (languageCode && urls[languageCode]) || urls.default;
}

export function resolveStaticHeaderResourceUrl(
  value: string,
  packageUrl: string
): string | undefined {
  try {
    return new URL(value, packageUrl).href;
  } catch (_error) {
    return undefined;
  }
}

export function isSameStaticHeaderPackageResource(
  resourceUrl: string,
  packageUrl: string
): boolean {
  try {
    const resource = new URL(resourceUrl);
    const packageDirectory = new URL(".", packageUrl);

    return (
      resource.protocol === "https:" &&
      resource.origin === STATIC_HEADER_ORIGIN &&
      !resource.username &&
      !resource.password &&
      resource.pathname.startsWith(packageDirectory.pathname)
    );
  } catch (_error) {
    return false;
  }
}
